export default __webpack_public_path__ + "static/media/Plywod_Durk.9c9c6b43.JPG";